import React, { useState,useEffect } from 'react'
import "../styles/home.css"
import Material from '../shope/material/materials'
import Category from '../shope/category/Categories'
import Post from './Post'
import { useSearchParams,useNavigate,Link, useLocation } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faStore } from '@fortawesome/free-solid-svg-icons';

export default function Home({propsData}) {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const matches = useMediaQuery('(max-width:1060px)');

  let navigate=useNavigate()
useEffect(()=>{
  if(!tab&&matches){
    navigate("/?tab=posts")
  }
  if((!matches&&!tab)||(!matches&&tab==="posts")){
    navigate("/")
  }

},[matches,tab])



  return (
    <div className={`${matches&&"home-minimized"}`}>
        
        <div className={`home-container ${(matches)&&"home-container-minimized"} ${(tab&&!matches)&&"home-container-tab"}`}>
            {tab==="categories"&&<div className={`${matches&&"home-container-minimized-single-page"} ${tab==="categories"&&"home-container-minimized-single-page-full"}`}> <Category tab={"full"} propsData={propsData} /></div>}
            {tab==="materials"&&<div className={`${matches&&"home-container-minimized-single-page"} ${tab==="materials"&&"home-container-minimized-single-page-full"}`}> <Material tab={"full"} propsData={propsData} /></div>}
            {tab==="posts"&&<div className={matches&&"home-container-minimized-single-page"}> <Post tab={"full"} propsData={propsData} /></div>}

            {(!tab&&!matches)&& 
                <>
                    <div className="home-container-category"><Category  propsData={propsData} /></div>
                    <div style={{marginTop:"25px",width:"100%"}}><Post  propsData={propsData} /></div>
                    <div className="home-container-material"><Material  propsData={propsData} /></div>
                  </>
              }

          
          </div>

        {(matches)&&
          <div className="home-container-header">
              <div className="home-container-header-box">
                  <div  className={tab==="categories"&&"home-container-header-active-button"}> 
                    <Link to="/?tab=categories" style={{textDecoration:"none",color:"inherit"}}>
                        <Tooltip title="Categories">
                             <IconButton  > <FontAwesomeIcon icon={faList} style={{fontSize:"20px"}} /> </IconButton>
                        </Tooltip>
                      </Link>
                    </div>
                  <div className={tab==="posts"&&"home-container-header-active-button"}> 
                        <Link to="/?tab=posts" style={{textDecoration:"none",color:"inherit"}}>
                            <Tooltip title="Posts">
                              <IconButton > <FontAwesomeIcon  icon={faPlus} style={{fontSize:"20px"}} /> </IconButton>

                            </Tooltip>
                        </Link>
                    </div>
                  <div  className={tab==="materials"&&"home-container-header-active-button"}> 
                     <Link to="/?tab=materials" style={{textDecoration:"none",color:"inherit"}}>
                       <Tooltip title="Materials">
                         <IconButton  > <FontAwesomeIcon style={{fontSize:"20px"}} icon={faStore} /> </IconButton>
                       </Tooltip>
                     </Link></div>
                </div>

          </div>
          }
         

    </div>
  )
}
/**
 *  <>
                  {tab==="materials"?
                      <Material tab={"full"} propsData={propsData} />
                    :
                      
                    }
              </>
 * <>
                            <div className="home-container-category"><Category  propsData={propsData} /></div>
                            <div className="home-container-post"><Post  propsData={propsData} /></div>
                            <div className="home-container-material"><Material  propsData={propsData} /></div>
                      </>
 */